import React from 'react';

export default function FinanceTab() {
	return (
		<div style={{ minHeight: '500px !important', padding: '2em' }}>
			FinanceTab
		</div>
	);
}
